import { useTranslation } from 'react-i18next';
import type { SelectedOption } from './useAllocationFilters';

const MAX_NAMED_PROFESSIONALS = 2;

export function useProfessionalsChip() {
  const { t } = useTranslation('alocacao');

  return (professionals: SelectedOption[]): { text: string; title: string } | null => {
    if (professionals.length === 0) return null;
    const field = t('filtros.chips.profissionais', { count: professionals.length });
    const names = professionals.map((option) => option.name);
    const hidden = names.length - MAX_NAMED_PROFESSIONALS;
    const name =
      hidden > 0
        ? t('filtros.chips.eMais', {
            names: names.slice(0, MAX_NAMED_PROFESSIONALS).join(', '),
            count: hidden,
          })
        : names.join(', ');
    return {
      text: t('filtros.chips.selecionado', { field, name }),
      title: t('filtros.chips.selecionado', { field, name: names.join(', ') }),
    };
  };
}
